// Utilities
import { sortAll } from "src/infinity-ui";

// Templates
import { arcRatingItems } from "./ARC.rating-items";

export function arcRatingGroups(ratingGroups: Array<any>): Array<any> {
    return ratingGroups.sort(sortByDisplaySequence).reduce((arr, group) => {    // Sort by display sequence and iterate over groups:
        if (!group.visible) return arr;                                         // Only include visible groups.
        return group.programEnrollmentRatingItems.reduce((arr, item) => {       // Iterate over items.
            if (item.parentItemId) return arr;                                  // Only include top level items.
            sortAll(item, "relatedItems", "displaySequence");                   // Sort item children by display sequence.
            return arr.concat(arcRatingItems(item, group));                     // Add form items to array.
        }, arr);
    }, []);
}

function sortByDisplaySequence(a, b) {
    return a.displaySequence - b.displaySequence;
}
